// javascript
// app/javascript/controllers/template_fields_controller.js
import { Controller } from "@hotwired/stimulus"
import { createApp, h } from "vue"
import TemplateFieldBuilder from "../components/dashboard/templates/TemplateFieldBuilder.vue"

export default class extends Controller {
    static targets = ["mount", "hidden", "kind", "category", "subcategory"]
    static values = {
        taxonomy: Object,
        defaultFields: Object,
        kind: String,
        category: String,
        subcategory: String
    }
    connect() {
        this.initialFields = this.mountTarget.dataset.initialFields
            ? JSON.parse(this.mountTarget.dataset.initialFields)
            : []

        this.mountVueBuilder(this.initialFields);
        console.log(this.taxonomyValue, this.kindValue, this.categoryValue, this.subcategoryValue,)
        console.log(this.categoryTarget, this.kindTarget, this.subcategoryTarget)
        this.populateCategories()
        this.populateSubcategories()

        if (this.hasCategoryTarget) {
            this.categoryTarget.addEventListener("change", this.handleCategoryChange)
        }

        if (this.hasKindTarget) {
            this.kindTarget.addEventListener("change", this.handleKindChange)
        }
    }
    mountVueBuilder(fields) {
        console.log("mountVueBuilder", fields)
        console.log("mountVueBuilder", fields)
        if (this.app) {
            this.app.unmount()
        }
        this.app = createApp({
            render: () =>
                h(TemplateFieldBuilder, {
                    initialFields: fields,
                    onUpdate: (updatedFields) => {
                        const json = JSON.stringify(updatedFields)
                        if (this.hasHiddenTarget) this.hiddenTarget.value = json
                    }
                })
        })

        this.vm = this.app.mount(this.mountTarget)
        if (this.hasHiddenTarget) this.hiddenTarget.value = JSON.stringify(fields)
    }

    disconnect() {
        if (this.hasCategoryTarget) {
            this.categoryTarget.removeEventListener("change", this.handleCategoryChange)
        }

        if (this.hasKindTarget) {
            this.kindTarget.removeEventListener("change", this.handleKindChange)
        }
        if (this.app) this.app.unmount()
    }

    handleKindChange = () => {
        this.categoryValue = ""
        this.subcategoryValue = ""
        if (this.hasCategoryTarget) this.categoryTarget.value = ""
        if (this.hasSubcategoryTarget) this.subcategoryTarget.value = ""
        this.populateCategories()
        this.populateSubcategories()


        const kind = this.hasKindTarget ? this.kindTarget.value : this.kindValue
        const defaultFields = this.defaultFieldsValue[kind] || []
        this.mountVueBuilder(defaultFields)
    }

    handleCategoryChange = () => {
        this.subcategoryValue = ""
        if (this.hasSubcategoryTarget) this.subcategoryTarget.value = ""
        this.populateSubcategories()
    }

    populateCategories() {
        if (!this.hasCategoryTarget) return

        const kind = this.hasKindTarget ? this.kindTarget.value : this.kindValue
        const categories = this.taxonomyValue[kind] || {}
        const currentCategory = this.categoryTarget.value || this.categoryValue || ""

        this.categoryTarget.innerHTML = ""
        this.categoryTarget.appendChild(this.buildOption("", "Select a category"))

        Object.keys(categories).forEach((category) => {
            this.categoryTarget.appendChild(this.buildOption(category, category))
        })

        if (categories[currentCategory]) {
            this.categoryTarget.value = currentCategory
        } else {
            this.categoryTarget.value = ""
        }
    }

    populateSubcategories() {
        if (!this.hasSubcategoryTarget || !this.hasCategoryTarget) return

        const kind = this.hasKindTarget ? this.kindTarget.value : this.kindValue
        const category = this.categoryTarget.value
        const categories = this.taxonomyValue[kind] || {}
        const subcategories = categories[category] || []
        const currentSubcategory = this.subcategoryTarget.value || this.subcategoryValue || ""

        this.subcategoryTarget.innerHTML = ""
        this.subcategoryTarget.appendChild(this.buildOption("", "Select a subcategory"))

        subcategories.forEach((subcategory) => {
            this.subcategoryTarget.appendChild(this.buildOption(subcategory, subcategory))
        })

        if (subcategories.includes(currentSubcategory)) {
            this.subcategoryTarget.value = currentSubcategory
        } else {
            this.subcategoryTarget.value = ""
        }
    }

    buildOption(value, label) {
        const option = document.createElement("option")
        option.value = value
        option.textContent = label
        return option
    }
}